module.exports = __webpack_public_path__ + "img/visa.9529af70.png";